
import { Component, Vue } from 'vue-property-decorator';
import TagRepositoryInterface, { TagInterface } from '../../../../services/QA/tag/interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { EditTagForm } from '@/services/QA/tag/forms/EditTagForm';

@Component({
  inject: [
    'tagRepository',
  ],
})
export default class EditTag extends Vue {
  private tag!: TagInterface;
  private readonly tagRepository!: TagRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<EditTagForm> = new WPXFormValue(EditTagForm);

  public async created(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  private async initialize(): Promise<void> {
    if (!this.$route.params.tagId) {
      this.$errorDialog.show('Tag Id Not Provided');
    }

    this.tag = await this.tagRepository.getOneById(Number(this.$route.params.tagId));
    this.form.data.label = this.tag.label;
    this.form.data.color = this.tag.color;
  }

  private async editTag(): Promise<void> {
    try {
      await this.tagRepository.editTag(
        this.tag.id,
        {
          label: this.form.data.label,
          color: this.form.data.color,
        },
      );

      this.$successDialog.show(`Tag '${this.form.data.label}' has been edited`);
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }
}
